<template lang="pug">
.menu  
  menu-item(:label=`$t('load_profile')`, @click="module.load")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { ObjectProfileModule } from '@/modules/ssp_database/ObjectProfileModule';

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: ObjectProfileModule
}
</script>

<i18n>
en:
  load_profile: Load Profile
ja:
  load_profile: プロファイルを読み込み

</i18n>